import { of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { RootEpic } from '~/Store/types'
import { errorNotification } from '~/Services'
import { UsersActions } from './slice'
import { UserService } from '~/Services/AdminUsers'


const getAllUsers: RootEpic = (action$) =>
  action$.pipe(
    filter(UsersActions.getUsersRequest.match),
    switchMap(() =>
      UserService.Get.getAllUsers().then(res =>
        UsersActions.setUsersSuccess(res.data)
      ).catch(error => {
        errorNotification(error)
        return UsersActions.setUsersError()
      })
    )
  )


const updateUser: RootEpic = (action$) =>
  action$.pipe(
    filter(UsersActions.updateUsersRequest.match),
    switchMap(action =>
      UserService.Post.createUser({
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
        email: action.payload.email,
        password: (action.payload as any).password,
        forcePasswordChange: true,
      })
        .then(() => UsersActions.updateUsersuccess(action.payload))
        .catch(error =>
          UsersActions.updateUsersError(error.message || 'Update user failed')
        )
    )
  )

export const UsersEpics = [getAllUsers, updateUser]
